module.exports = __webpack_public_path__ + "static/media/7.30cedc10.svg";